/* eslint-disable */
import { EventService } from '@/store/event/event-service'
import Message from '@/shared/message/toastify'
import Errors from '@/shared/error/errors'
import { i18n } from '@/locales/i18n'
import router from '@/router'
import { collection, doc, getFirestore } from 'firebase/firestore'
import { FileUploader } from '@/shared/uploader/file-uploader'

export default {
  namespaced: true,

  state: {
    findLoading: false,
    saveLoading: false,
    record: null
  },

  getters: {
    record: state => state.record,
    findLoading: state => !!state.findLoading,
    saveLoading: state => !!state.saveLoading
  },

  mutations: {
    RESET(state) {
      state.findLoading = false
      state.saveLoading = false
      state.record = null
    },

    FIND_STARTED(state) {
      state.record = null
      state.findLoading = true
    },
    FIND_SUCCESS(state, payload) {
      state.record = payload
      state.findLoading = false
    },
    FIND_ERROR(state) {
      state.record = null
      state.findLoading = false
    },

    CREATE_STARTED(state) {
      state.saveLoading = true
    },
    CREATE_SUCCESS(state) {
      state.saveLoading = false
    },
    CREATE_ERROR(state) {
      state.saveLoading = false
    },

    UPDATE_STARTED(state) {
      state.saveLoading = true
    },
    UPDATE_SUCCESS(state) {
      state.saveLoading = false
    },
    UPDATE_ERROR(state) {
      state.saveLoading = false
    }
  },

  actions: {
    doNew({ commit }) {
      commit('RESET')
    },

    async doFind({ commit }, id) {
      try {
        commit('FIND_STARTED')
        const record = await EventService.find(id)
        commit('FIND_SUCCESS', record)
      } catch (error) {
        Errors.handle(error)
        commit('FIND_ERROR')
        router.push('/event')
      }
    },

    async doCreate({ commit }, { values, imageEn, imageAr }) {
      try {
        commit('CREATE_STARTED')
        const id = doc(collection(getFirestore(), 'ids')).id

        // [1] Upload images to storage of firebase
        const path = `events/${id}`
        // const { publicUrl } = await FileUploader.upload(path, image, id)
        const imgEN = await FileUploader.upload(path, imageEn, 'event-en')
        const imgAR = await FileUploader.upload(path, imageAr, 'event-ar')

        await EventService.create({
          ...values,
          image: { en: imgEN.publicUrl, ar: imgAR.publicUrl }
        })
        commit('CREATE_SUCCESS')

        Message.success(i18n('event.create.success'))
        router.push('/event')
      } catch (error) {
        Errors.handle(error)
        commit('CREATE_ERROR')
      }
    },

    async doUpdate({ commit }, { id, values, imageEn, imageAr }) {
      try {
        commit('UPDATE_STARTED')
        // [1] Upload images to storage of firebase
        const storageId = doc(collection(getFirestore(), 'ids')).id

        const path = `events/${storageId}`
        // const { publicUrl } = await FileUploader.upload(path, image, id)
        const imgEN =
          typeof imageEn === 'object'
            ? await FileUploader.upload(path, imageEn, 'event-en')
            : imageEn
        const imgAR =
          typeof imageAr === 'object'
            ? await FileUploader.upload(path, imageAr, 'event-ar')
            : imageAr

        // values['image'] = publicUrl
        values.image.en = imgEN?.publicUrl || imgEN
        values.image.ar = imgAR?.publicUrl || imgAR
        await EventService.update(id, values)
        commit('UPDATE_SUCCESS')

        Message.success(i18n('event.update.success'))
        router.push('/event')
      } catch (error) {
        Errors.handle(error)
        commit('UPDATE_ERROR')
      }
    }
  }
}
